export default __webpack_public_path__ + "static/media/warning--divided-highway-on-right--g1.38f23cbf.png";